import React, { useEffect } from 'react';
import { Grid, Button, Box } from "@mui/material";
import { styles } from "./styles";
import { styles as inputStyles } from "common/inputStyles";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { CSVLink } from "react-csv";
import { Colors } from "assets/colors";

interface ActionButtons {
  label: string;
  icon?: any;
  onClickHandler: Function;
  buttonStyle: any;
}

interface DeviceStatusTableHeaderProps {
  searchVal: string;
  setSearchVal: Function;
  data: any;
  tabs?: Array<ActionButtons>;
  withFilter?: boolean;
  csvLabel?: string;
  setShowCont?: any;
  setFormattedData?:any;
  setCheckedData?:any
  formattedData?:any;
  checkedData?:any;
}

const DeviceStatusTableHeader: React.FC<DeviceStatusTableHeaderProps> = ({ searchVal, formattedData, setFormattedData, checkedData, setCheckedData, setSearchVal, data, tabs, csvLabel }) => {

  const transformUserRoles = (arr: any) => {
    let transformedArray: any = [];
    arr.forEach((obj: any) => {
      if (obj.hasOwnProperty('userRoleList')) {
        let transformedObj = { ...obj };
        if (transformedObj.hasOwnProperty('userId')) {
          delete transformedObj['userId'];
        }
        if (transformedObj.hasOwnProperty('timeZone')) {
          delete transformedObj['timeZone'];
        }
        if (transformedObj.hasOwnProperty('dateFormat')) {
          delete transformedObj['dateFormat'];
        }
        if (transformedObj.hasOwnProperty('numberFormat')) {
          delete transformedObj['numberFormat'];
        }
        if (transformedObj.hasOwnProperty('permissionCount')) {
          delete transformedObj['permissionCount'];
        }
        if (transformedObj.hasOwnProperty('recordNumber')) {
          delete transformedObj['recordNumber'];
        }
        if (transformedObj.hasOwnProperty('obsNumber')) {
          delete transformedObj['obsNumber'];
        }
        if (transformedObj.hasOwnProperty('Event Timestamp')) {
          delete transformedObj['Event Timestamp'];
        }
        if (transformedObj.hasOwnProperty('roleId')) {
          delete transformedObj['roleId'];
        }
        if (transformedObj.hasOwnProperty('truckName')) {
          delete transformedObj['truckName'];
        }
        if (transformedObj.hasOwnProperty('truckId')) {
          delete transformedObj['roleId'];
        }
        const userRoles = transformedObj['userRoleList'].map((roleObj: any) => roleObj['roleName']);
        transformedObj['userRoleList'] = userRoles.join(', ');
        transformedArray.push(transformedObj);
        //console.log(transformedObj)
      }
    });

    if (transformedArray.length > 0) {
      setCheckedData(transformedArray);
    } else {
      setCheckedData(data);
    }
  }

  const transformKey = (key: string) => {
    return key.replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
  };

  const transformObjectKeys = (obj: any) => {
    const transformedObj = Object.keys(obj).reduce((acc, key) => {
      const transformedKey = transformKey(key);
      return { ...acc, [transformedKey]: obj[key] };
    }, {});
    return transformedObj;
  };

  useEffect(() => {
    if (checkedData !== null && checkedData.length > 0) {
      let transformedArray = checkedData.map((obj: any) => transformObjectKeys(obj));
      console.log(transformedArray)
      let rArray: any = [];
      /*transformedArray.forEach((item:any,idx:number){
        console.log(item);
      });*/
      let eventRptData: any = [];
      for (var i = 0; i < transformedArray.length; i++) {
        let eventorderObj: any = {}; 
        eventorderObj["Device ID"] = transformedArray[i]["Device Name"];
        eventorderObj["Device Type"] = transformedArray[i]["Device Type"];
        eventorderObj["Device Status"] = transformedArray[i]["Device Status"];
        eventorderObj["Truck Type"] = transformedArray[i]["Truck Type"];
        eventorderObj["Service Type"] = transformedArray[i]["Service Type"];
        eventorderObj["Service Provider"] = transformedArray[i]["Service Provider"];
        eventorderObj["Segment Name"] = transformedArray[i]["Segment Name"];
        eventorderObj["Truck Number"] = transformedArray[i]["Truck Name"];
        eventorderObj["Last Reported On"] = transformedArray[i]["Last Reported Event Time"];
        eventorderObj["Event"] = transformedArray[i]["Last Reported Event Type"];
        eventorderObj["Received Time"] = transformedArray[i]["Received Time"];
        eventorderObj["Latitude"] = transformedArray[i]["Latitude"];
        eventorderObj["Longitude"] = transformedArray[i]["Longitude"];
        eventorderObj["Address"] = transformedArray[i]["Address"];
        eventorderObj["Observation Number"] = transformedArray[i]["Obs Number"];
        eventorderObj["Observation Description"] = transformedArray[i]["Obs Description"];
        eventorderObj["Last Image Url"] = transformedArray[i]["Last Image Url"];
        eventorderObj["Last Image Time"] = transformedArray[i]["Last Image Time"];
        eventorderObj["Last Image-2 Url"] = transformedArray[i]["Last Image-2 Url"];
        eventorderObj["Last Image-2 Time"] = transformedArray[i]["Last Image-2 Time"];

        eventRptData.push(eventorderObj);
      }
      setFormattedData(eventRptData);
    }
  }, [checkedData]);

  useEffect(() => {
    if (data.length > 0) {
      transformUserRoles(data);
    }
  }, [data]);

  return (
    <Grid item xs={12} sx={{ ...styles.container, justifyContent: tabs ? "space-between" : "flex-end" }} style={{margin: '0px'}}>
      {
        tabs &&
        <Grid sx={styles.buttonContainer}>
          {tabs.map((t, i) =>
            <Button key={i} sx={{ ...styles.buttons, ...t.buttonStyle, marginRight: 0 }} onClick={() => t.onClickHandler()}>
              {t.icon && t.icon}
              {t.label}
            </Button>
          )}
        </Grid>
      }
      <Grid sx={styles.buttonContainer}>
        <CSVLink data={formattedData || []} style={{ textDecoration: 'none' }} filename={csvLabel ? csvLabel : 'download.csv'}>
          <Button sx={{ ...styles.buttons, backgroundColor: Colors.Purple }}>
            <FileDownloadOutlinedIcon sx={{ marginRight: ".5rem" }} />
            Download CSV
          </Button>
        </CSVLink>
        <Box sx={inputStyles.searchContainer}>
          <SearchOutlinedIcon sx={{ marginLeft: ".5rem" }} />
          <input type="text" placeholder='Search' value={searchVal} onChange={(e) => setSearchVal(e.target.value)} />
        </Box>
      </Grid>
    </Grid>
  )
}

export default DeviceStatusTableHeader;